import React from 'react';
import Box from '@nubank/nuds-web/components/Box/Box';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Link from '@nubank/nuds-web/components/Link/Link';
import styled from 'styled-components';
import Image from '@nubank/nuds-web/components/Image/Image';
import { useParallax } from 'react-scroll-parallax';
import Grid from '@nubank/nuds-web/components/Grid/Grid';

const StyledTitle = styled(Typography)`
  span {
    /* stylelint-disable property-no-vendor-prefix, property-no-unknown */
    background-image: linear-gradient(137.07deg, #9F2DEB 42.83%, #6200A3 86.85%);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
  }

  @media (width >= 1150px) {
    font-size: 2.2rem;
  }
`;

const StyledLogoImage = styled(Image)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: auto;
`;

const StyledScreenImage = styled(Image)`
  display: flex;
  align-items: end;
  justify-content: end;
`;

const StyledLink = styled(Link)`
  align-items: center;
  display: flex;
  justify-content: left;
  width: 100%;

  @media (width >= 1150px) {
    justify-content: center;
  }
`;

function AppleAndGooglePay() {
  const { ref } = useParallax({
    opacity: [0, 1],
    easing: [0, 0.9, 1, 1.4],
  });

  return (
    <Box
      tag="section"
      height="100%"
      width="100%"
      marginBottom={{ xs: '16x', lg: '100px' }}
      paddingHorizontal={{ xs: '32px', lg: '56px' }}
    >
      <Grid
        paddingLeft={{ xs: '0', lg: '0' }}
        paddingRight={{ xs: '0', lg: '0' }}
      >

        {/* CONTENT BOX */}

        <Grid.Child
          gridColumn={{ xs: '1 / span 4', md: '2 / span 4', lg: '2 / span 10' }}
          gridRow="1"
        >
          <StyledTitle
            variant="heading3"
            textAlign={{ xs: 'center' }}
            whiteSpace="pre-line"
            ref={ref}
          >
            Dile
            {' '}
            <span>adiós a tu cartera</span>
            {' '}
            con
            {'\n'}
            {' '}
            Apple Pay y Billetera de Google
          </StyledTitle>

          <Box
            marginTop={{ xs: '40px', lg: '76px' }}
            display="flex"
            flexDirection={{ xs: 'column', lg: 'row' }}
            alignItems={{ xs: 'center', lg: 'center' }}
            justifyContent={{ xs: 'center', lg: 'space-between' }}
            width="100%"
          >

            {/* APPLE PAY */}

            <Box width="100%">
              <Box
                display="flex"
                background="#202124"
                height={{ xs: '150px', lg: '100%' }}
                borderRadius="12px"
                marginBottom={{ xs: '20px', lg: '20px' }}
                justifyContent="space-around"
                alignItems="center"
                paddingLeft={{ xs: '24px', lg: '0' }}
                paddingRight={{ xs: '24px', lg: '0' }}
              >
                <StyledLogoImage
                  alt="Logo de Apple"
                  webP={false}
                  src="credit-card/wallet/apple.svg"
                  width={{ xs: '100px', lg: '140px' }}
                  loading="lazy"
                />

                <StyledScreenImage
                  alt="Un celular con la pantalla de Apple Pay"
                  webP
                  src="credit-card/wallet/apple-screen.png"
                  width={{ xs: '108px', lg: '200px' }}
                  height="100%"
                  loading="lazy"
                />
              </Box>

              <StyledLink
                href="https://nu.com.mx/ayuda/apple-pay/"
                iconProps={{ name: 'arrow-up-right' }}
              >
                Conoce todo de Apple Pay
              </StyledLink>
            </Box>

            {/* GOOGLE WALLET */}

            <Box width="100%" marginLeft={{ xs: '0', lg: '50px' }}>
              <Box
                display="flex"
                background="#202124"
                height={{ xs: '150px', lg: '100%' }}
                width="100%"
                borderRadius="12px"
                marginBottom={{ xs: '20px', lg: '20px' }}
                justifyContent="space-around"
                alignItems="center"
                marginTop={{ xs: '40px', lg: '0' }}
                paddingLeft={{ xs: '24px', lg: '50px' }}
                paddingRight={{ xs: '24px', lg: '24px' }}
              >
                <StyledLogoImage
                  alt="Logo de Google wallet"
                  webP={false}
                  src="credit-card/wallet/google.svg"
                  width={{ xs: '151px', lg: '240px' }}
                  loading="lazy"
                />

                <StyledScreenImage
                  alt="Un celular con la pantalla de Google Wallet"
                  webP
                  src="credit-card/wallet/google-screen.png"
                  width={{ xs: '108px', lg: '200px' }}
                  height="100%"
                  loading="lazy"
                />
              </Box>

              <StyledLink
                href="https://nu.com.mx/ayuda/billetera-de-google/"
                iconProps={{ name: 'arrow-up-right' }}
              >
                Conoce todo de Billetera de Google
              </StyledLink>
            </Box>
          </Box>
        </Grid.Child>
      </Grid>
    </Box>
  );
}

export default AppleAndGooglePay;
